// extracted by mini-css-extract-plugin
module.exports = {"featureImg":"blogArticle_featureImg__JDvKK","articleBody":"blogArticle_articleBody__RRBHt"};